import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f3fcbde8")

_pushScopeId("data-v-f3fcbde8")
const _hoisted_1 = {
  key: 0,
  class: "\n        bg-gray-lp-300\n        text-white text-center\n        rounded\n        p-2\n        fixed\n        z-60\n        items-center\n        bold\n        text-14px\n        fixed-position\n      "
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    onEnter: _ctx.enter
  }, {
    default: _withId(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onEnter"]))
})